var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKpmgDefaultFileDisabled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.134,
    height: 19.252,
    viewBox: "0 0 15.134 19.252"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".kpmg-default-file-disabled_svg__cls-2{fill:none;stroke:#e5e2e2;stroke-linecap:round;stroke-width:1.6px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kpmg-default-file-disabled_svg__ICN_Alte_extensii_Disabled",
    "data-name": "ICN_Alte extensii_Disabled",
    transform: "translate(-421.091 -403.97)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kpmg-default-file-disabled_svg__Group_698",
    "data-name": "Group 698",
    transform: "translate(421.891 404.77)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kpmg-default-file-disabled_svg__Group_611",
    "data-name": "Group 611"
  }, /*#__PURE__*/React.createElement("path", {
    id: "kpmg-default-file-disabled_svg__Path_823",
    d: "M3.663 0h6.208l3.663 3.663V13.99a3.663 3.663 0 01-3.663 3.663H3.663A3.663 3.663 0 010 13.99V3.663A3.663 3.663 0 013.663 0z",
    "data-name": "Path 823",
    strokeWidth: 1.6,
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#e5e2e2",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-default-file-disabled_svg__Path_822",
    d: "M0 .6v3.632",
    className: "kpmg-default-file-disabled_svg__cls-2",
    "data-name": "Path 822",
    transform: "translate(9.615 -.463)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-default-file-disabled_svg__Line_62",
    d: "M0 0h3.663",
    className: "kpmg-default-file-disabled_svg__cls-2",
    "data-name": "Line 62",
    transform: "translate(9.615 3.769)"
  }))))));
}

export default SvgKpmgDefaultFileDisabled;